// Types
import { ServerSideApplicationVariables } from '@/types/env';

/** **IMPORTANT**: SHOULD NOT BE CONSUMED IN CLIENT RENDERED CODE! */
export const applicationEnv: ServerSideApplicationVariables = {
  PortalId: process.env.PORTAL_ID ?? '',
  WebsiteName: process.env.WEBSITE_NAME ?? '',
  GoogleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY ?? '',
  GoogleTagManagerId: process.env.GOOGLE_TAG_MANAGER_ID ?? '',
  GoogleAnalyyticsCookieKey: process.env.GOOGLE_ANALYTICS_COOKIE_KEY ?? '',

  IsLocalisationEnabled:
    process.env.IS_LOCALISATION_ENABLED === 'true' ? true : false,
  IsTestEnvironment: process.env.IS_TEST_ENVIRONMENT === 'true' ? true : false,

  PrismicEnvironmentPagesSecret:
    process.env.PRISMIC_ENVIRONMENT_PAGES_SECRET ?? null,
  PrismicWebhookRevalidateSecret:
    process.env.PRISMIC_WEBHOOK_REVALIDATE_SECRET ?? null,

  AlgoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY ?? null,
  AlgoliaApplicationId: process.env.ALGOLIA_APPLICATION_ID ?? null,
  AlgoliaSearchApiKey: process.env.ALGOLIA_SEARCH_ONLY_API_KEY ?? null,
  PrismicWebhookSiteSearchSecret:
    process.env.PRISMIC_WEBHOOK_SITE_SEARCH_SECRET ?? null,
};
